@if (!editMode) {
  <div>
    @if (data !== undefined) {
      <div class="html-block-area">
        <div [innerHTML]="data || htmlData" class="html-preview-content"></div>
      </div>
    }
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="form-content">
    <textarea formControlName="{{ fieldConfig.name }}" matInput value="{{ data }}"></textarea>
  </mat-form-field>
}
